export const FETCH_CURRENT_REQUEST = 'partners/FETCH_CURRENT_REQUEST'
export const FETCH_CURRENT_SUCCESS = 'partners/FETCH_CURRENT_SUCCESS'
export const FETCH_CURRENT_FAILURE = 'partners/FETCH_CURRENT_FAILURE'

export const CREATE_PARTNER_REQUEST = 'partners/CREATE_PARTNER_REQUEST'
export const CREATE_PARTNER_SUCCESS = 'partners/CREATE_PARTNER_SUCCESS'
export const CREATE_PARTNER_FAILURE = 'partners/CREATE_PARTNER_FAILURE'
